/**
 * Compatibility shim for packages that do named ESM imports from `react-dom`,
 * e.g. `import { findDOMNode } from 'react-dom'`.
 *
 * With React 18 + webpack 5, `react-dom` is CommonJS and some packages' ESM builds
 * trigger "Attempted import error: 'findDOMNode' is not exported from 'react-dom'".
 *
 * This shim MUST remain CommonJS:
 * - `react-dom/client` itself is CommonJS and does `require('react-dom')`.
 * - If this file is ESM, that require() would receive `{ default: ... }` instead of the
 *   actual ReactDOM object, and React will crash trying to access its internals.
 *
 * IMPORTANT: We load ReactDOM via a separate alias (`react-dom-original`) to avoid
 * webpack alias recursion (webpack will alias `react-dom` to this file).
 */
// eslint-disable-next-line import/no-commonjs
const ReactDOM = require('react-dom-original');

// Default export (CJS) must be the actual ReactDOM object.
// eslint-disable-next-line import/no-commonjs
module.exports = ReactDOM;

// Help ESM default import interop: `import ReactDOM from 'react-dom'`.
module.exports.default = ReactDOM;

// Explicit named exports for ESM named-import consumers.
module.exports.createPortal = ReactDOM.createPortal;
module.exports.findDOMNode = ReactDOM.findDOMNode;
module.exports.flushSync = ReactDOM.flushSync;
module.exports.hydrate = ReactDOM.hydrate;
module.exports.render = ReactDOM.render;
module.exports.unmountComponentAtNode = ReactDOM.unmountComponentAtNode;
module.exports.unstable_batchedUpdates = ReactDOM.unstable_batchedUpdates;
module.exports.unstable_renderSubtreeIntoContainer =
  ReactDOM.unstable_renderSubtreeIntoContainer;
